/* eslint-disable max-len */
import { Accordion, AccordionProps, styled } from "@mui/material";

import React from "react";

interface SocAccordionProps extends AccordionProps {
    expanded: boolean;
    dynamicStyles?: boolean;
};

interface IAccordionHeaderProps {
  dynamicStyles?: boolean;
}

const commonStylesAccordion = ({ theme, expanded, dynamicStyles }:
    { theme: any, expanded: boolean, dynamicStyles?: boolean }) => ({
  "&.MuiAccordion-root": {
    "boxShadow": "none",
    "transition": ".3s all",
    "minHeight": !dynamicStyles ? "3.6rem": "1rem",


    "& .MuiAccordionSummary-expandIconWrapper": {
      rotate: "270deg",
    },
    "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
      transform: "rotate(270deg)",
    },

    "& .MuiAccordionSummary-root": {
      "padding": 0,
      "minHeight": !dynamicStyles ?"unset" : undefined,
      "& .MuiAccordionSummary-content": {
        display: "grid",
        margin: 0,
        alignItems: "center",
      },
    },
    "&:before": {
      display: dynamicStyles ? "none !important" : undefined,
    },
  },
});


export const SocAccordion = styled(({ expanded, dynamicStyles, ...props }: SocAccordionProps)=>(
  <Accordion expanded={expanded} {...props}/>
))(({ theme, expanded, dynamicStyles })=>({
  ...commonStylesAccordion({ theme, expanded }),
  "border": `1px solid ${theme.palette.taupe.dark}`,
  "padding": dynamicStyles ? "1rem" : undefined,
}));

export const SocChildAccordion = styled(({ expanded, dynamicStyles, ...props }: SocAccordionProps)=>(
  <Accordion expanded={expanded} {...props} />
))(({ theme, expanded, dynamicStyles })=>({
  ...commonStylesAccordion({ theme, expanded, dynamicStyles }),
  "&.Mui-expanded": {
    "boxShadow": "none",
  },
  "&.Mui-expanded:not(:first-of-type)": {
    "borderTop": !dynamicStyles ? `1px solid ${theme.palette.taupe.dark}` : undefined,
  },
}));

export const SocReminderCardAccordion = styled(({ expanded, dynamicStyles, ...props }: SocAccordionProps)=>(
  <Accordion expanded={expanded} {...props}/>
))(({ theme, expanded, dynamicStyles })=>({
  ...commonStylesAccordion({ theme, expanded }),
  "borderBottom": `1px solid ${theme.palette.taupe.dark}`,
  "padding": dynamicStyles ? "0.5rem" : undefined,
  "&:last-of-type": {
    borderBottomLeftRadius: "0px !important",
    borderBottomRightRadius: "0px !important",
  },
}));


export const AccordionHeader = styled("div")<IAccordionHeaderProps>(({ theme, dynamicStyles=false }) => ({
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "space-between",
  "padding": dynamicStyles ? "1rem 0px" : "1rem",
  ".title_icon": {
    display: "flex",
    alignItems: "center !important",
    gap: "1rem",
    flexShrink: 0,
    flexGrow: 1,
  },
}));

export const AccordionDetailsChild = styled("div")(({ theme })=>({
  "padding": "0px 1rem",
  "display": "flex",
  "flexDirection": "column",
  "gap": "12px",
  "alignItems": "flex-start",
  "alignSelf": "stretch",
  ".soc_date": {
    display: "flex",
    gap: "4px",
  },
}));


export const SocReminderCardContainer = styled("div")(({ theme })=>({
  "padding": "1rem",
  "borderRadius": "0.5rem",
  "position": "relative",
  "backgroundColor": theme.palette.white.main,
  "boxShadow": "0.125rem 0.125rem 1.125rem 0rem rgba(55, 54, 23, 0.10)",
  "border": `1px solid ${theme.palette.taupe.dark}`,

  ".child_container": {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    flex: "1 0 0",
    gap: "1rem",
  },

  ".title": {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    flexShrink: 0,
    flexGrow: 1,
    paddingBottom: "0.5rem",
    borderBottom: `1px solid ${theme.palette.taupe.dark}`,
  },
}));
